import axiosInstance from "../lib/axiosInstance";

const Videomodel = class {
  constructor() {
    this.baseUrl = "/adminapi/questions/";
    this.staticData = [
      {
        id: 1,
        question: "What is the capital of India?",
        category: [
          { name: "General Knowledge" },
          { name: "CBSE" },
          { name: "Class 8" },
          { name: "Social Studies" },
        ],
      },
      {
        id: 2,
        question: "Explain the process of photosynthesis.",
        category: [
          { name: "Science" },
          { name: "ICSE" },
          { name: "Class 9" },
          { name: "Biology" },
        ],
      },
      {
        id: 3,
        question: "Solve: 2x + 3 = 7",
        category: [
          { name: "Mathematics" },
          { name: "CBSE" },
          { name: "Class 7" },
          { name: "Algebra" },
        ],
      },
      {
        id: 4,
        question: "Who wrote Romeo and Juliet?",
        category: [
          { name: "English Literature" },
          { name: "ICSE" },
          { name: "Class 10" },
          { name: "Shakespeare" },
        ],
      },
      {
        id: 5,
        question: "What is the chemical formula for water?",
        category: [
          { name: "Chemistry" },
          { name: "CBSE" },
          { name: "Class 9" },
          { name: "Basic Chemistry" },
        ],
      },
      {
        id: 6,
        question: "Define democracy and its types.",
        category: [
          { name: "Civics" },
          { name: "CBSE" },
          { name: "Class 8" },
          { name: "Political Science" },
        ],
      },
      {
        id: 7,
        question: "Calculate the area of a circle with radius 5cm.",
        category: [
          { name: "Mathematics" },
          { name: "ICSE" },
          { name: "Class 8" },
          { name: "Geometry" },
        ],
      },
      {
        id: 8,
        question: "Explain the water cycle.",
        category: [
          { name: "Geography" },
          { name: "CBSE" },
          { name: "Class 6" },
          { name: "Environmental Science" },
        ],
      },
    ];
  }

  async list(data = []) {
    try {
      // Simulate API delay
      await new Promise((resolve) => setTimeout(resolve, 500));

      return {
        data: this.staticData,
        meta: {
          current_page: 1,
          per_page: 20,
          total_page: Math.ceil(this.staticData.length / 20),
        },
      };
    } catch (error) {
      console.error("Error fetching video questions:", error);
      throw error;
    }
  }

  async listbyVideoQuesid(data = []) {
    return await axiosInstance.get(`${this.baseUrl}?id=${data}`);
  }
  async removeVideoQue(data = {}) {
    return await axiosInstance.delete(`${this.baseUrl}?id=${data}`);
  }

  async create(data = []) {
    return await axiosInstance.post(this.baseUrl, data);
  }

  async editVideoQue(data = []) {
    return await axiosInstance.put(this.baseUrl, data);
  }
};

export default new Videomodel();
